import { ArrowUpRight } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { CtaBand } from "../components/CtaBand";
import { PARTNERS } from "../data/site";

export default function Partners() {
  return (
    <div data-testid="partners-page">
      <PageHeader
        overline="Partners"
        lines={["Trusted teams.", "Trusted suppliers."]}
        description="ABS LLC works alongside teams and suppliers we trust. These partners help us deliver complete support to every driver and program, from safety equipment and video to arrive-and-drive racing."
      />

      <section data-testid="partners-list" className="border-t border-neutral-200 bg-white">
        <div className="mx-auto grid max-w-7xl gap-px bg-neutral-200 px-0 md:grid-cols-2">
          {PARTNERS.map((p, i) => (
            <Reveal key={p.name} delay={0.06 * i} className="bg-white">
              <article data-testid={`partner-${i + 1}`} className="flex h-full flex-col p-8 md:p-12">
                <div
                  className={`flex h-40 items-center justify-center border border-neutral-200 px-8 ${
                    p.dark ? "bg-[#161616]" : "bg-white"
                  }`}
                >
                  <img src={p.logo} alt={`${p.name} logo`} loading="lazy" className="max-h-28 max-w-full object-contain" />
                </div>
                <h2 className="font-display mt-8 text-2xl font-bold tracking-tight text-[#111111] md:text-3xl">{p.name}</h2>
                <p className="mt-4 flex-1 text-base leading-relaxed text-neutral-600">{p.text}</p>
                <a
                  href={p.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group mt-8 inline-flex items-center gap-2 self-start border border-[#111111] px-6 py-3 text-[12px] font-semibold uppercase tracking-[0.16em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-white"
                >
                  Visit {p.domain}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
